import React from 'react'
import styled from 'styled-components'
import {
  Clock,
  PlayCircle,
  PauseCircle,
  CheckCircle2,
  XCircle,
  Send,
  Eye,
  DollarSign,
  UserCheck,
  AlertCircle
} from 'lucide-react'

const StyledChip = styled.div`
  display: inline-flex;
  align-items: center;
`

const StyledText = styled.span`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  color: ${({ color }) => `${color}`};
  background: ${({ backgroundColor }) => `${backgroundColor}`};
  padding: 6px 12px;
  border-radius: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 500;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  transition: all 0.2s ease;
  border: 1px solid ${({ borderColor }) => borderColor || 'transparent'};
  
  svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    stroke-width: 2.5;
    color: ${({ iconColor }) => iconColor || 'inherit'};
    fill: ${({ iconColor }) => iconColor || 'currentColor'};
    stroke: ${({ iconColor }) => iconColor || 'currentColor'};
    opacity: 1;
  }
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    
    svg {
      color: ${({ iconColor }) => iconColor || 'inherit'};
      fill: ${({ iconColor }) => iconColor || 'currentColor'};
      stroke: ${({ iconColor }) => iconColor || 'currentColor'};
      opacity: 1;
    }
  }

`


const ChipStatusVariants = ({ status, onClick, noStyle = false }) => {
    if(noStyle){
      switch(status) {
        case 'pending':
          return <span onClick={onClick}>
              Pendente
          </span>
        case 'in_progress':
          return <span onClick={onClick}>
              Em Progresso
          </span>
        case 'stand_by':
          return <span onClick={onClick}>
              Stand-by
          </span>
        case 'waiting_approval':
          return <span onClick={onClick}>
              Aguardando Aprovação
          </span>
        case 'in_estimating':
          return <span onClick={onClick}>
              Aguardando Orçamento
          </span>
        case 'draft':
          return <span onClick={onClick}>
              Pendente de Informação
          </span>
        case 'demand_sent':
          return <span onClick={onClick}>
              Demanda Enviada
          </span>
        case 'in_review':
          return <span onClick={onClick}>
              Aguardando Revisão
          </span>
        case 'canceled':
          return <span onClick={onClick}>
              Cancelado
          </span>
        case 'done':
          return <span onClick={onClick}>
              Demanda Concluída
          </span>
        case 'waiting_estimate_approval':
          return <span onClick={onClick}>
              Aguardando Aprovação do Orçamento
          </span>
        case "waiting_lawyer_acceptance":
          return <span onClick={onClick}>
              Aguardando Aceite do Advogado
          </span>
        default:
          return <span onClick={onClick}>
              Demanda solicitada
          </span>
      }
    }else{
      switch(status) {
        case 'pending':
          return <StyledChip onClick={onClick}>
            <StyledText backgroundColor={'rgba(251, 191, 36, 0.15)'} color={'#f59e0b'} iconColor={'#d97706'} borderColor={'rgba(251, 191, 36, 0.3)'} data-status="pending">
              <Clock /> Pendente
            </StyledText>
          </StyledChip>
        case 'in_progress':
          return <StyledChip onClick={onClick}>
            <StyledText backgroundColor={'rgba(59, 130, 246, 0.15)'} color={'#2563eb'} iconColor={'#1d4ed8'} borderColor={'rgba(59, 130, 246, 0.3)'} data-status="in_progress">
              <PlayCircle /> Em Progresso
            </StyledText>
          </StyledChip>
        case 'stand_by':
          return <StyledChip onClick={onClick}>
            <StyledText backgroundColor={'rgba(156, 163, 175, 0.15)'} color={'#6b7280'} iconColor={'#4b5563'} borderColor={'rgba(156, 163, 175, 0.3)'} data-status="stand_by">
              <PauseCircle /> Stand-by
            </StyledText>
          </StyledChip>
        case 'waiting_approval':
          return <StyledChip onClick={onClick}>
            <StyledText backgroundColor={'rgba(249, 115, 22, 0.15)'} color={'#f97316'} iconColor={'#ea580c'} borderColor={'rgba(249, 115, 22, 0.3)'} data-status="waiting_approval">
              <UserCheck /> Aguardando Aprovação
            </StyledText>
          </StyledChip>
        case 'in_estimating':
          return <StyledChip onClick={onClick}>
            <StyledText backgroundColor={'rgba(168, 85, 247, 0.15)'} color={'#9333ea'} iconColor={'#7e22ce'} borderColor={'rgba(168, 85, 247, 0.3)'} data-status="in_estimating">
              <DollarSign /> Aguardando Orçamento
            </StyledText>
          </StyledChip>
        case 'draft':
          return <StyledChip onClick={onClick}>
            <StyledText backgroundColor={'rgba(239, 68, 68, 0.15)'} color={'#dc2626'} iconColor={'#b91c1c'} borderColor={'rgba(239, 68, 68, 0.3)'} data-status="draft">
              <AlertCircle /> Pendente de Informação
            </StyledText>
          </StyledChip>
        case 'demand_sent':
          return <StyledChip onClick={onClick}>
            <StyledText backgroundColor={'rgba(34, 197, 94, 0.15)'} color={'#16a34a'} iconColor={'#15803d'} borderColor={'rgba(34, 197, 94, 0.3)'} data-status="demand_sent">
              <Send /> Demanda Enviada
            </StyledText>
          </StyledChip>
        case 'in_review':
          return <StyledChip onClick={onClick}>
            <StyledText backgroundColor={'rgba(245, 158, 11, 0.15)'} color={'#d97706'} iconColor={'#b45309'} borderColor={'rgba(245, 158, 11, 0.3)'} data-status="in_review">
              <Eye /> Aguardando Revisão
            </StyledText>
          </StyledChip>
        case 'canceled':
          return <StyledChip onClick={onClick}>
            <StyledText backgroundColor={'rgba(220, 38, 38, 0.15)'} color={'#b91c1c'} iconColor={'#991b1b'} borderColor={'rgba(220, 38, 38, 0.3)'} data-status="canceled">
              <XCircle /> Cancelado
            </StyledText>
          </StyledChip>
        case 'done':
          return <StyledChip onClick={onClick}>
            <StyledText backgroundColor={'rgba(22, 163, 74, 0.15)'} color={'#15803d'} iconColor={'#166534'} borderColor={'rgba(22, 163, 74, 0.3)'} data-status="done">
              <CheckCircle2 /> Concluído
            </StyledText>
          </StyledChip>
        case 'waiting_estimate_approval':
          return <StyledChip onClick={onClick}>
            <StyledText backgroundColor={'rgba(147, 51, 234, 0.15)'} color={'#7e22ce'} iconColor={'#6b21a8'} borderColor={'rgba(147, 51, 234, 0.3)'} data-status="waiting_estimate_approval">
              <DollarSign /> Aguardando Aprovação do Orçamento
            </StyledText>
          </StyledChip>
        case "waiting_lawyer_acceptance":
          return <StyledChip onClick={onClick}>
            <StyledText backgroundColor={'rgba(99, 102, 241, 0.15)'} color={'#6366f1'} iconColor={'#4f46e5'} borderColor={'rgba(99, 102, 241, 0.3)'} data-status="waiting_lawyer_acceptance">
              <UserCheck /> Aguardando Aceite do Advogado
            </StyledText>
          </StyledChip>
        // case "in_auction":
        //     return <div className="status-chip">Em Leilão</div>
        // case "transfered_lawyer":
        //     return <div className="status-chip">Transferência de Advogado</div>
        // case "without_history":
        //     return <div className="status-chip">Sem Status / Status não Registrado</div>
        default:
          return <StyledChip onClick={onClick}>
            <StyledText backgroundColor={'#D6FBD3'} color={'#49A96A'}>
              Demanda solicitada
            </StyledText>
          </StyledChip>
      }
    }


}

export default ChipStatusVariants;
